/* eslint-disable @typescript-eslint/naming-convention */
export interface BaseResponse<T> {
  Data: T;
  HasError: boolean;
  Message: string;
}

export interface BaseResponseCamelCase<T> {
  data: T;
  hasError: boolean;
  message: string;
}
